export default "__VITE_ASSET__BxZ52cXb__"